// Shared helpers for the Derwent Finance Client Portal (Phase 1).
export const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
export const TOKEN_KEY = 'client_token';
export const CLIENT_INFO_KEY = 'client_info';

export const STAGE_STATUS_LABELS = {
  not_started: 'Not started',
  in_progress: 'In progress',
  waiting_on_client: 'Waiting on you',
  waiting_on_lender: 'With the lender',
  completed: 'Completed',
  issue: 'Needs attention',
};

export const STAGE_STATUS_STYLES = {
  not_started: 'bg-slate-100 text-slate-500 ring-slate-200',
  in_progress: 'bg-amber-50 text-amber-700 ring-amber-200',
  waiting_on_client: 'bg-orange-50 text-orange-700 ring-orange-200',
  waiting_on_lender: 'bg-sky-50 text-sky-700 ring-sky-200',
  completed: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  issue: 'bg-rose-50 text-rose-700 ring-rose-200',
};

export const DOC_STATUS_LABELS = {
  requested: 'Action needed',
  uploaded: 'Under review',
  under_review: 'Under review',
  approved: 'Approved',
  rejected: 'Re-upload required',
  needs_replacement: 'Re-upload required',
};

export const DOC_STATUS_STYLES = {
  requested: 'bg-amber-50 text-amber-800 ring-amber-200',
  uploaded: 'bg-sky-50 text-sky-700 ring-sky-200',
  under_review: 'bg-sky-50 text-sky-700 ring-sky-200',
  approved: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  rejected: 'bg-rose-50 text-rose-700 ring-rose-200',
  needs_replacement: 'bg-rose-50 text-rose-700 ring-rose-200',
};

export const CLIENT_TYPE_LABELS = {
  payg: 'PAYG employee',
  self_employed: 'Self-employed',
  investor: 'Investor',
  first_home_buyer: 'First-home buyer',
};

export function formatCurrency(value) {
  if (value == null) return '—';
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  }).format(Number(value));
}

export function formatDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  } catch (_) {
    return iso;
  }
}

export function getClientToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getClientInfo() {
  try {
    const raw = localStorage.getItem(CLIENT_INFO_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

export function setClientSession(token, client) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(CLIENT_INFO_KEY, JSON.stringify(client));
}

export function clearClientSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(CLIENT_INFO_KEY);
}

export async function clientApi(path, { method = 'GET', body, formData } = {}) {
  const token = getClientToken();
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  if (body && !formData) headers['Content-Type'] = 'application/json';
  const res = await fetch(`${backendUrl}/api${path}`, {
    method,
    headers,
    body: formData ? formData : body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    clearClientSession();
    if (window.location.pathname.startsWith('/client-portal')) {
      window.location.assign('/client-portal');
    }
    throw new Error('Session expired');
  }
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const j = await res.json();
      if (j?.detail) detail = j.detail;
    } catch (_) {}
    throw new Error(detail);
  }
  if (res.headers.get('content-type')?.includes('application/json')) {
    return res.json();
  }
  return res;
}
